<script>import ButtonBox from "./ButtonBox.svelte";
import { attrValue } from "../../../../utils/html";
export let props = {};
</script>

<ButtonBox
	props={{
		...props,
		classNames: attrValue([
			props.classNames,
			'border text-primary border-primary bg-transparent box-border h-[48px]'
		])
	}}
	on:click
/>
